import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function ButtonBack({ ...props }) {
  return (
    <Button
      sx={{ color: "#000", textTransform: "initial" }}
      size="small"
      startIcon={<ArrowBackIcon />}
      {...props}
    >
      Voltar
    </Button>
  );
}
